var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12481_165002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.1654C0 14.1807 2.46328 16.6258 5.50094 16.6258C8.53861 16.6258 11.0019 14.1807 11.0019 11.1654C11.0019 8.15007 5.50094 0.625824 5.50094 0.625824C5.50094 0.625824 0 8.15007 0 11.1654ZM7.59887 5.98346C9.2354 7.76685 10.7947 10.4214 9.7307 12.9151C9.03955 14.534 7.11299 15.6369 5.3597 15.1958C5.27119 15.2257 5.2919 15.1789 5.3597 15.1958C6.82486 14.6985 7.86064 13.8685 8.50659 12.3094C9.64972 9.54649 7.54802 5.92925 7.59887 5.98533V5.98346Z",
    fill: "#343330"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12481_165002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 16,
    fill: "white",
    transform: "translate(0 0.625824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilIcon);
export default __webpack_public_path__ + "static/media/OilIcon.5cb58c72.svg";
export { ForwardRef as ReactComponent };